import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { CableDiameter } from '@/types/openapi'

export type QuantityFilter = 'length' | 'spoolsNumber'

export type StockFilters = {
  quantityFilter: QuantityFilter
  diameter: CableDiameter[]
}

export type StockState = {
  filters: StockFilters
  actions: {
    setDiameterFilter: (diameter: CableDiameter[]) => void
    setQuantityFilter: (quantityFilter: QuantityFilter) => void
    resetFilters: () => void
  }
}

const DEFAULT_FILTERS: StockFilters = {
  quantityFilter: 'length',
  diameter: [],
}

export const useStockStore = create<StockState>()(
  persist(
    (set) => ({
      filters: DEFAULT_FILTERS,
      actions: {
        setDiameterFilter: (diameter) =>
          set((state) => ({
            filters: { ...state.filters, diameter },
          })),
        setQuantityFilter: (quantityFilter) =>
          set((state) => ({
            filters: { ...state.filters, quantityFilter },
          })),
        resetFilters: () => set({ filters: DEFAULT_FILTERS }),
      },
    }),
    {
      name: 'mobiway-stock-filters',
      merge: (persistedState, currentState) => {
        const persistedFilters = (persistedState as Partial<StockState>)?.filters
        const persistedDiameter = persistedFilters?.diameter

        return {
          ...currentState,
          filters: {
            ...currentState.filters,
            ...persistedFilters,
            diameter: Array.isArray(persistedDiameter) ? persistedDiameter : persistedDiameter ? [persistedDiameter] : [],
          },
        }
      },
      partialize: (state) => ({
        filters: state.filters,
      }),
    }
  )
)
